module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAYAAAArK+5dAAAACXBIWXMAAAsSAAALEgHS3X78AAAAV0lEQVRIDWNc6sbawEA78ICFgYGhXsuQg+o2fPv8j+HBnV8HQBYwaBlQ34LXL/6ALGBgwpChMhi1YNSCUQtGLRi1YNSCUQuIAuBKf838D7S2h0aAgYEBAF0TEefS2XdOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-yellow-1.png
// module id = 243
// module chunks = 0